import React from 'react';
import Translation from '../../_flux/components/translation/translation';
import {handleView} from '../handle_view';
import openAlternativeProductStockOnClick from '../catalog_items/open_alternative_product_stock_onlick';
import {formatToCurrency} from '../../_modules/currency/format_to_currency';

const renderMoreAvailableTyreLink = (states, options) => {
    const formattedPrice = formatToCurrency(options.price, options.currencyIsoCode, false, true, {});
    return (
        <span className="catalog-stock-warning__label">
            <Translation
                tagName="p"
                translationKey="product-remaining-stock-more-available"
                placeholder={{stock: options.stock, price: formattedPrice}}
            />
        </span>
    );
};

const getOptions = options => ({
    ...options,
});

export const init = (container, options) =>
    handleView({}, renderMoreAvailableTyreLink, getOptions(options), container);
